type SinglePick = {
  gameId: string;
  gameIndex?: number;
  teamId?: string;
  name?: string;
  teamAlias?: string;
  logo?: string;
  opponent?: {
    teamId: string;
    name: string;
    seed?: number;
  };
  label?: string;
  status?: PickStatus;
  isWinning?: boolean;
  isBestPick?: boolean;
  seed?: number;
};

export const enum PickStatus {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
}

export const enum PickVariant {
  PICK_BAR = 'PICK_BAR',
  MY_ENTRIES = 'MY_ENTRIES',
}

export type { SinglePick };
